import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo5.jpg'


const _hoisted_1 = { class: "nav-menu" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_tree = _resolveComponent("menu-tree")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [
        [_vShow, !_ctx.menuFold]
      ])
    ]),
    _createVNode(_component_el_menu, {
      class: "el-menu-vertical",
      "background-color": "#fff",
      "text-color": "#333333",
      "active-text-color": "#F18201",
      collapse: _ctx.menuFold,
      router: "",
      "default-active": _ctx.activeRouter,
      "unique-opened": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_menu_tree, { userMenus: _ctx.userMenus }, null, 8, ["userMenus"])
      ]),
      _: 1
    }, 8, ["collapse", "default-active"])
  ]))
}